export interface FAQ {
  id: string;
  title: string;
  answerHtml: string;
}

export const DAFAPLUS_FAQS: FAQ[] = [
  {
    id: '1',
    title: 'What is DafaPlus?',
    answerHtml: `
      <p>DafaPlus is the brand new hybrid crypto-casino and sportsbook for players who love and use cryptocurrency.</p>
      <p>DafaPlus gives you access to exclusive new games, bonuses and many new amazing opportunities. Welcome to the new gaming experience!</p>
    `,
  },
  {
    id: '2',
    title: 'What is $GAMEON?',
    answerHtml: `
      <p>$GAMEON is the loyalty program embedded in DafaPlus, where players can accumulate $GAMEON points.</p>
      <p>These points can be redeemed for actual $GAMEON cryptocurrency with a real-world value. Players can choose to wager with their earned $GAMEON tokens on DafaPlus, or withdraw them to their crypto wallet and buy or sell them on an exchange.</p>
    `,
  },
  {
    id: '3',
    title: 'What is cryptocurrency?',
    answerHtml: `
      <p>Cryptocurrency is a digital asset that uses cryptography to help execute transactions, prove ownership and even run smart contracts.</p>
      <p>Aside from being a digital asset, cryptocurrencies also function as decentralized networks and even as systems of accounting. Cryptocurrencies are:</p>
      <ul>
        <li><strong>Decentralized</strong> - working on a non-centralized network of computers</li>
        <li><strong>Permissionless</strong> - allowing users to send and receive their digital assets however they want</li>
        <li><strong>Secure</strong> - immune to hacks, attacks and malicious actors</li>
      </ul>
      <p>Every transaction on any given cryptocurrency network is permanent and irreversible.</p>
    `,
  },
  {
    id: '4',
    title: 'How is cryptocurrency different from traditional money?',
    answerHtml: `
      <p>Traditional money is issued and controlled by governments and banks. Cryptocurrency is digital money that runs on decentralized blockchain networks without any central authority.</p>
      <p>Banks process and verify transactions while crypto uses code and distributed computers across the world to confirm transactions. Cryptocurrency is borderless and transparent, but more volatile.</p>
    `,
  },
  {
    id: '5',
    title: 'Why do people like cryptocurrency?',
    answerHtml: `
      <p>Cryptocurrency lets you send money globally in seconds, without banks and intermediaries, and is usually much cheaper than using banks. It gives access to digital payments where banking is limited or non-existent, protects savings in high-inflation countries, and allows full control of funds.</p>
      <p>It also enables earning, investing, and online commerce without middlemen. Cryptocurrency and blockchain technology allow people from all over the world to benefit from many financial services that were previously unavailable.</p>
    `,
  },
  {
    id: '6',
    title: 'Which cryptocurrencies are accepted on DafaPlus?',
    answerHtml: `
      <p>We currently accept:</p>
      <ul>
        <li>USDT (on the Tron and Ethereum networks)</li>
        <li>USDC (on the Ethereum network)</li>
        <li>Litecoin (LTC)</li>
        <li>Bitcoin (BTC)</li>
        <li>Dash (DASH)</li>
        <li>Ethereum (ETH)</li>
        <li>Ripple (XRP)</li>
        <li>Dogecoin (DOGE)</li>
        <li>Avalanche (AVAX)</li>
        <li>Solana (SOL)</li>
        <li>Polkadot (DOT)</li>
        <li>Cardano (ADA)</li>
        <li>Near Protocol (NEAR)</li>
        <li>Polygon (POL - previously known as MATIC)</li>
      </ul>
      <p>We will keep expanding our roster of popular coins and tokens for your convenience.</p>
    `,
  },
  {
    id: '7',
    title: 'What is the difference between a coin and a token?',
    answerHtml: `
      <p>A coin is native to a particular blockchain and is used to pay the network fees on that blockchain. For example, on Ethereum all transactions require a fee in $ETH, and on Bitcoin the network fee is paid in $BTC.</p>
      <p>A token is built on top of an existing blockchain, such as Ethereum, BSC or Tron. It can represent access to an app, voting rights, stable value, utility or even ownership of assets.</p>
      <p>USDT is a token that works on several different networks. If you want to send USDT on the Tron network (TRC20 token standard), you will need a bit of $TRX to pay the network transaction fees.</p>
      <p>If you want to send USDT on the Ethereum network (ERC20 token standard), you will need a bit of $ETH to pay the network transaction fees.</p>
    `,
  },
  {
    id: '8',
    title: 'How safe is cryptocurrency?',
    answerHtml: `
      <p>Cryptocurrency itself is built on secure blockchain technology, which is virtually impossible to hack. Some coins use better encryption standards than banks and large financial institutions. The biggest risks while using cryptocurrency are scams, hacks or human error.</p>
      <p>When you use cryptocurrency, it is important to understand that you take 100% responsibility over your digital assets. This means safe storage, management and transactions.</p>
      <p>Continue exploring our FAQ to learn more about the risks and how you can keep your coins and tokens safe.</p>
    `,
  },
  {
    id: '9',
    title: 'What is a stablecoin?',
    answerHtml: `
      <p>A stablecoin is a cryptocurrency token designed to maintain a stable value to a fiat currency such as the USD or EUR.</p>
      <p>Unlike Bitcoin, the price of a stablecoin does not swing wildly. Many people use stablecoins for payments, trading, and saving in crypto without volatility. The largest and most famous stablecoins are USDT and USDC. You can use your stablecoins to wager on DafaPlus.</p>
    `,
  },
  {
    id: '10',
    title: 'What is a Level-Up-Coin?',
    answerHtml: `
      <p>Level-Up-Coins are playable credit tokens designed to enhance your DafaPlus gaming experience. They work on the blockchain and allow users to seamlessly transfer playable credit across the entire DafaPlus ecosystem, as well as store them inside their own crypto wallet.</p>
      <p>Level-Up-Coins are native to different countries and help players use a comfortably familiar unit of currency. DafaPlus allows players to use $MUDRA (India), $THO (Thailand), $NOVIX (Korea) and $YBAO (China).</p>
      <p>Level-Up-Coins are not stablecoins. However, for the comfort and familiarity of native currencies they follow their value very closely, without severe fluctuations.</p>
    `,
  },
  {
    id: '11',
    title: 'How does cryptocurrency work?',
    answerHtml: `
      <p>Cryptocurrency works through a technology called blockchain. It is a distributed digital ledger shared across thousands of computers worldwide.</p>
      <p>When you send cryptocurrency, your transaction is broadcast to the network. Special participants called validators or miners verify it using cryptography to ensure you actually own the funds and are not double-spending them.</p>
      <p>Once verified, the transaction is grouped with others into a block and permanently added to the chain. This record is transparent and impossible to alter. No bank or central authority controls this automated system. Instead, the rules are enforced by code running on every computer that joins the network.</p>
    `,
  },
  {
    id: '12',
    title: 'What is a public address and private key?',
    answerHtml: `
      <p>In cryptocurrency, a public key and private key work together to secure your funds using cryptography.</p>
      <p>Your private key is like your password, PIN and signature combined. It looks like a random string of letters and numbers and proves you own and control cryptocurrency. If someone steals your private key, they can control your funds.</p>
      <p>Your public address is similar to your bank account number. It is generated with the help of your private key. You can share your public addresses with anyone you wish to receive cryptocurrency from.</p>
      <p>Most cryptocurrency wallets hide the private key behind a seed phrase of 12 to 24 words. Whoever controls the private key controls the crypto. Always write down your seed phrase on paper and never give it to anyone.</p>
    `,
  },
  {
    id: '13',
    title: 'Are crypto transactions reversible?',
    answerHtml: `
      <p>Crypto transactions are irreversible. There is no bank or central authority that can cancel, freeze or refund them. This is why it is critical to verify every transaction and review the deposit and withdrawal address twice before executing a blockchain transaction.</p>
      <p>The immutable and irreversible nature of blockchain transactions makes crypto secure and censorship-resistant, but it also means mistakes can be costly.</p>
      <p>Always double-check addresses and amounts before confirming a transaction. If you are working with cryptocurrency transactions for the first time, make small test transactions before sending your main amount.</p>
    `,
  },
  {
    id: '14',
    title: 'How can I buy cryptocurrency?',
    answerHtml: `
      <p>To buy crypto, you can choose a trusted centralized exchange like Bybit, Kraken or WazirX. Create an account, verify your identity where required by law, and provide a payment method such as a bank account, debit card, credit card or UPI.</p>
      <p>Next, choose the cryptocurrency you want to buy, enter the amount, and confirm the purchase.</p>
      <p>It is important to understand that a centralized exchange account is not a cryptocurrency wallet. You can keep your coins and tokens on the exchange for a short time, but for better security consider moving them to a personal wallet where you control the private keys.</p>
    `,
  },
  {
    id: '15',
    title: 'Can I deposit my cryptocurrency to DafaPlus from my centralised exchange account?',
    answerHtml: `
      <p>This is possible, but it is not the best option for security. If you want to own your coins and tokens, it is best to withdraw them into your own non-custodial wallet and only then send them to your DafaPlus deposit address.</p>
    `,
  },
  {
    id: '16',
    title: 'Can I withdraw my cryptocurrency from DafaPlus into my centralized exchange account?',
    answerHtml: `
      <p>You can, but always remember that your centralised exchange account is not a true cryptocurrency wallet. You do not own this account, and if you make a mistake and lose your funds during the withdrawal process, many centralized exchanges will not help you recover them.</p>
      <p>It is always better and safer to withdraw your winnings into your own non-custodial cryptocurrency wallet.</p>
    `,
  },
  {
    id: '17',
    title: 'How do I safely store and manage my cryptocurrency?',
    answerHtml: `
      <p>The safest way to store crypto is in a non-custodial wallet where you control the private keys. This is usually an app on your computer or phone that lets you store, use and manage different kinds of coins and tokens.</p>
      <p>Your wallet is considered non-custodial when only you hold and control your private keys.</p>
      <p>Remember that exchange wallets such as Binance, Bybit and WazirX are always custodial. You do not own the private keys and you risk having your coins frozen at any time.</p>
    `,
  },
  {
    id: '18',
    title: 'What wallet options do I have?',
    answerHtml: `
      <p>There are several types of non-custodial cryptocurrency wallets, each with different security levels:</p>
      <ol>
        <li><strong>Hardware wallets</strong> (also called cold storage wallets) are physical devices that look like a flash drive. Your private keys stay offline at all times and are only used to sign transactions.</li>
        <li><strong>Software wallets</strong> (also called multicoin hot wallets) are apps on your phone or computer. They are easy to use, fast, and usually support many coins and tokens.</li>
        <li><strong>Web or exchange wallets</strong> are provided by centralised exchanges. They are not viable cryptocurrency wallets and should not be treated as a safe long-term storage option.</li>
        <li><strong>Web3 wallets</strong> are non-custodial wallets that let you interact with the broader Web3 ecosystem, including decentralized exchanges, bridges and NFT platforms.</li>
      </ol>
      <p>New cryptocurrency users usually start with software wallets and explore other options as they become more comfortable using crypto transactions.</p>
      <p>The most important question to ask is, who owns the private keys?</p>
      <p>When you own your private key, always make a wallet backup by writing down your 12 to 24 word recovery phrase on paper. If something happens to your phone or computer, you can use this phrase to recover your wallet and the coins and tokens in it.</p>
    `,
  },
  {
    id: '19',
    title: 'How do I deposit cryptocurrency into DafaPlus?',
    answerHtml: `
      <p>Your deposit options are located in the Cashier. When you choose the deposit option, you will be presented with:</p>
      <ul>
        <li>A deposit address</li>
        <li>The network type for your token</li>
        <li>The amount you wish to deposit</li>
      </ul>
      <p>You can either scan the QR code with your crypto wallet on your phone, or copy the deposit address and paste it into your wallet.</p>
      <p>Please make sure you are always using the correct token standard, for example TRC20 for the Tron network or ERC20 for the Ethereum network.</p>
      <p>If you are making your crypto transaction for the first time, consider sending a small test transaction after checking the minimum required amount in Cashier. Once it arrives safely into your DafaPlus account, you can proceed with your main deposit amount.</p>
    `,
  },
  {
    id: '20',
    title: 'How do I withdraw cryptocurrency from DafaPlus into my wallet?',
    answerHtml: `
      <p>Congratulations on your winnings. Here is how you can withdraw your coins and tokens:</p>
      <ol>
        <li>Head to the Cashier and select Withdraw.</li>
        <li>Open your own non-custodial wallet and copy your coin or token address.</li>
        <li>Paste your address into the Cashier and verify the first and last 8 characters.</li>
        <li>Select your token, network and amount, then confirm your withdrawal.</li>
      </ol>
      <p>The coins or tokens will shortly arrive in your wallet.</p>
      <p><strong>Important:</strong> Always verify your withdrawal address and the network for your token. If you are withdrawing for the first time, consider sending only a small amount as a test transaction before withdrawing the rest.</p>
    `,
  },
  {
    id: '21',
    title: 'How do I keep my cryptocurrency safe?',
    answerHtml: `
      <p>Keeping cryptocurrency safe comes down to controlling your private keys and avoiding the most common scams. Use a hardware wallet for large amounts and store your recovery phrase offline in a secure place, preferably written on paper. Never take screenshots of your recovery phrase and never keep it in cloud storage.</p>
      <p>Always enable two-factor authentication on centralized crypto exchanges and use strong, unique passwords. Double-check wallet addresses before sending funds, and make small test transactions first.</p>
      <p>Never share your seed phrase with anyone. No legitimate company will ever ask for it. If someone has it, they can take your crypto instantly.</p>
    `,
  },
  {
    id: '22',
    title: 'What are the most common risks in cryptocurrency?',
    answerHtml: `
      <p>The most common risks in crypto are price volatility, regulation changes, technical mistakes and custody risk.</p>
      <p>Cryptocurrency prices can rise or fall very quickly. Governments may introduce new rules that impact cryptocurrency around the world. Players can lose funds by sending to the wrong address or losing private keys. Centralized exchanges can be hacked or freeze withdrawals entirely.</p>
      <p>Unlike banks, there is usually no insurance or recovery system in cryptocurrency. Take time to learn the basics and test with small transactions. As you become comfortable with cryptocurrency, you can greatly reduce your risk.</p>
    `,
  },
  {
    id: '23',
    title: 'What are the most common scams in cryptocurrency?',
    answerHtml: `
      <p>The most common crypto scams include phishing, fake investment schemes and impersonation.</p>
      <p>Phishing tricks you into revealing your seed phrase through fake websites or emails. Always keep your private keys and recovery phrases secret. Nobody at DafaPlus will ever ask for this information.</p>
      <p>Guaranteed return schemes promise high profits but are often Ponzi scams. If something looks too good to be true, it usually is.</p>
      <p>Scammers also pose as support staff, influencers or even friends asking for crypto. Fake airdrops and malicious links can drain wallets. These schemes often create artificial urgency and pressure you to act immediately.</p>
      <p>Always keep your cool and keep your sensitive wallet data secret. Stay safe and report any suspicious activity to our support team.</p>
    `,
  },
  {
    id: '24',
    title: 'Is cryptocurrency private?',
    answerHtml: `
      <p>Cryptocurrency is often misunderstood as being fully private. Most major coins like Bitcoin and Ethereum are actually pseudonymous, not anonymous.</p>
      <p>All transactions are recorded on a public blockchain that anyone can view. Wallet addresses do not show your name, but they can sometimes be linked to you through exchanges or analysis tools.</p>
      <p>In general, crypto is transparent by default, not completely private.</p>
    `,
  },
  {
    id: '25',
    title: 'What can I do to avoid crypto deposit and withdrawal mistakes?',
    answerHtml: `
      <p>To avoid deposit and withdrawal mistakes on DafaPlus, always double-check three things:</p>
      <ul>
        <li>The wallet address</li>
        <li>The blockchain network</li>
        <li>The asset type</li>
      </ul>
      <p>Sending funds to the wrong network, for example ERC-20 instead of BEP-20, can result in permanent loss of your tokens.</p>
      <p>If you are using cryptocurrency for the first time, start with a small test transaction before moving large amounts. Copy and paste addresses carefully and verify the first and last 8 characters.</p>
      <p>Also check minimum deposit amounts, required memos or tags for coins like XRP, and withdrawal fees before confirming. If you have any questions, our live support team will gladly assist you.</p>
    `,
  },
];